<bw-action-article
  *ngIf="contentDisplay"
  [brightsideWebFb]="{ event_name: 'invite_welcome', custom: {type: referrerType}}"
>
  <div content-section>
    <div class="flex-column mt-xl mb-md">
      <img src="../assets/{{ contentDisplay.imageName }}.svg" [alt]="contentDisplay.imageName" class="mb-md" />
      <p text-medium-regular class="mb-sm">{{ contentDisplay.titleKey | translate:{name:firstName} }}</p>
      <typography text-large-semibold [ngSwitch]="referrerName">
        <div *ngSwitchCase="''"><div [innerHTML]="contentDisplay.textBodyKey | translate"></div></div>
        <div *ngSwitchDefault><div [innerHTML]="contentDisplay.optionalTextBodyKey | translate:{name:referrerName}"></div></div>
      </typography>
    </div>
  </div>

  <div footer-actions>
    <button
      bw-button
      fluidWidth
      (click)="handleClick()"
    >
      {{ contentDisplay.ctaKey | translate }}
    </button>
    <typography *ngIf="contentDisplay.secondaryCtaKey !== ''" text-medium-regular class="mt-sm">
      <a bw-anchor (click)="handleClick(true);">
        {{ contentDisplay.secondaryCtaKey | translate:{name:firstName} }}
      </a>
    </typography>
  </div>
</bw-action-article>
